import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/solid'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'
import { AppsBlock } from '@/components/entities/common/ui/AppsBlock'
import { AppModal } from '@/components/shared/modal'
import { QrStoreType } from '@/components/widgets/sidebar/ui/Sidebar.types'
import { formatPhoneNumber, makePhoneCallable } from '@/utils/number'

type Props = {
  opened: boolean
  onClose: () => void
  setQrStore: (appLinkType: QrStoreType) => void
  setQrOpened: (isOpen: boolean) => void
}

const ContactsModal = ({ opened, onClose, setQrStore, setQrOpened }: Props) => {
  const { data: contactInfo, isLoading: contactInfoLoading } = useContactInfo()

  return (
    <AppModal
      className="!w-[400px] !bg-grey-100"
      headerClassName="!text-white"
      header="Служба комфорта 24/7"
      opened={opened}
      onClose={onClose}
      contentClassName="flex flex-col gap-8 pb-32 mt-12"
      closeButtonClassName="bg-white/10 hover:bg-white/20"
      closeButtonIconClassName="text-bronze-40"
    >
      {contactInfo?.contactPhone && (
        <a
          href={`tel:${makePhoneCallable(contactInfo.contactPhone)}`}
          className="flex items-center gap-12 font-bold text-white text-24 hover:text-grey-70"
        >
          <PhoneIcon className="h-24 w-24 text-white" />
          {contactInfoLoading
            ? 'Загружается...'
            : formatPhoneNumber(contactInfo.contactPhone)}
        </a>
      )}

      {contactInfo?.contactEmail && (
        <a
          href={`mailto:${contactInfo.contactEmail}`}
          className="flex items-center gap-12 font-pro text-bronze-40 text-18 hover:text-bronze-60"
        >
          <EnvelopeIcon className="h-24 w-24 text-white" />
          {contactInfoLoading ? 'Загружается...' : contactInfo.contactEmail}
        </a>
      )}

      {(contactInfo?.contactPhone || contactInfo?.contactEmail) && (
        <hr className="my-12 text-grey-70" />
      )}

      <AppsBlock setQrStore={setQrStore} setQrOpened={setQrOpened} />
    </AppModal>
  )
}

export { ContactsModal }
